import axios from './configAxios';

export const putGroupApi = async (group_id, requestData) => {
    return axios.put(`${group_id}/update/`, requestData);
  };
